import React from "react";
import { Box, Button, MenuItem, Select, TextField } from "@mui/material";
import ActionFooter from "../../../Shared/ActionFooter/ActionFooter";
import AppletProfileSession from "../../../../models/session/applet-profile-session.entity";
import FieldLabel from "../../../Shared/FieldLabel/FieldLabel";

const InspectionProfileNative = (props: any) => {
  const {
    profiles,
    handleChanges,
    selectedProfile,
    plate,
    onChangePlate,
    startInspection,
    isAgriculturalProfile,
    vehicleType,
    onChangeVehicleType,
    brand,
    onChangeBrand,
    version,
    onChangeVersion,
    yearManufacture,
    onChangeYearManufacture,
  } = props;

  const PLATE_REGEX = /^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/;
  const isPlateValid = isAgriculturalProfile
    ? !!plate
    : PLATE_REGEX.test(plate);
  const showPlateError = !isAgriculturalProfile && !!plate && !isPlateValid;
  const isMachineDataValid = !isAgriculturalProfile
    || (!!vehicleType && !!brand && !!version && !!yearManufacture);
  const isFormValid = !!selectedProfile && isPlateValid && isMachineDataValid;

  const identificationTitle = isAgriculturalProfile ? 'Digite a identificação do veículo' : 'Perfil de vistoria';
  const identificationLabel = isAgriculturalProfile ? 'Número de identificação' : 'Placa';
  const identificationPlaceholder = isAgriculturalProfile ? 'Número de identificação' : 'Placa';
  const identificationErrorText = 'Placa inválida. Use o formato AAA0A00.';

  return (
    <Box
      component="div"
      className="inspection"
      sx={{
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
      }}
    >
      <Box sx={{ margin: '0 20px', width: '-webkit-fill-available' }}>
        <div style={{
          color: '#D40020',
          fontSize: '12px',
          textAlign: 'center',
          fontFamily: 'Poppins',
          fontWeight: 500,
          marginTop: '30px'
        }}>1 de 2</div>
        <div
          className="title"
          style={{
            width: '100%',
            textAlign: 'center',
            marginTop: '22px !important'
          }}
        >{identificationTitle}</div>
        <div className="description">
          Selecione o perfil desejado e informe a<br/>
          placa para prosseguir.
        </div>
        <FieldLabel required htmlFor="inspection-profile" style={{ marginTop: '20px' }}>
          Perfil de vistoria
        </FieldLabel>
        <Select
          fullWidth
          id="inspection-profile"
          variant="outlined"
          className="square-input"
          value={selectedProfile}
          onChange={handleChanges}
          data-testid="select-profile"
        >
          {profiles && profiles.map((profile: AppletProfileSession) => {
            return (
              <MenuItem
                value={profile.appletProfileId}
                key={profile.appletProfileId}
              >{profile.appletProfileTitle}</MenuItem>
            );
          })}

        </Select>
        <FieldLabel required htmlFor="inspection-plate" style={{ marginTop: '20px' }}>
          {identificationLabel}
        </FieldLabel>
        <TextField
          fullWidth
          id="inspection-plate"
          variant="outlined"
          className="square-input"
          placeholder={identificationPlaceholder}
          type="text"
          value={plate}
          onChange={onChangePlate}
          error={showPlateError}
          helperText={showPlateError ? identificationErrorText : ''}
          inputProps={{ maxLength: isAgriculturalProfile ? 17 : 7 }}
          data-testid="input-plate"
        />
        {isAgriculturalProfile && (
          <>
            <FieldLabel required htmlFor="inspection-vehicle-type" style={{ marginTop: '20px' }}>
              Tipo de veículo
            </FieldLabel>
            <TextField
              fullWidth
              id="inspection-vehicle-type"
              variant="outlined"
              className="square-input"
              placeholder="Insira o tipo de veículo"
              type="text"
              value={vehicleType}
              onChange={onChangeVehicleType}
              inputProps={{ maxLength: 100 }}
              data-testid="input-vehicle-type"
            />
            <FieldLabel required htmlFor="inspection-brand" style={{ marginTop: '20px' }}>
              Marca
            </FieldLabel>
            <TextField
              fullWidth
              id="inspection-brand"
              variant="outlined"
              className="square-input"
              placeholder="Marca"
              type="text"
              value={brand}
              onChange={onChangeBrand}
              inputProps={{ maxLength: 100 }}
              data-testid="input-brand"
            />
            <FieldLabel required htmlFor="inspection-version" style={{ marginTop: '20px' }}>
              Versão
            </FieldLabel>
            <TextField
              fullWidth
              id="inspection-version"
              variant="outlined"
              className="square-input"
              placeholder="Versão"
              type="text"
              value={version}
              onChange={onChangeVersion}
              inputProps={{ maxLength: 100 }}
              data-testid="input-version"
            />
            <FieldLabel required htmlFor="inspection-year" style={{ marginTop: '20px' }}>
              Ano
            </FieldLabel>
            <TextField
              fullWidth
              id="inspection-year"
              variant="outlined"
              className="square-input"
              placeholder="Ano"
              type="text"
              value={yearManufacture}
              onChange={onChangeYearManufacture}
              inputProps={{ maxLength: 4 }}
              data-testid="input-year-manufacture"
            />
          </>
        )}
      </Box>
      <ActionFooter>
        <Button
          fullWidth
          variant="outlined"
          className="primary-button"
          disabled={!isFormValid}
          onClick={() => { startInspection() }}
          data-testid="btn-new-inspection"
        >Próximo</Button>
      </ActionFooter>
    </Box>
  );
};

export default InspectionProfileNative;
